import React from 'react';
import { Events } from '../components';
import SimpleHeader from '../components/simple_header';

export default function EventsPage(){
    const [open, setOpen] = React.useState(false);

    const listRef = React.useRef<any>();

    return <>
        {/* <SimpleHeader title="Calendário" /> */}
        <Events.List ref={listRef} />
    </>
}
